/**
 * Body — SketchUp-true free geometry (FACE-EDGE KERNEL K1,
 * docs/bim-plan/21-face-edge-kernel-spike.md §3).
 *
 * The element's `params.topology` IS the face-edge graph (vertices/edges/faces —
 * body/types.ts), the recorded bounded exception to "params only, never geometry":
 * no parameter recipe regenerates a hand-drawn body. One body = one connected
 * component (§3.3) — the draw commands merge touching bodies (stickiness) and the
 * eraser splits disconnected ones, exactly the splitWall identity model.
 *
 * User-facing vocabulary is SketchUp's own (spike Q1, Matt: "go with what
 * SketchUp users say"): the label is "Geometry"; grouped bodies read "Group" /
 * "Solid Group" (K3). The TYPE is a single curated record whose material feeds
 * section/plan POCHÉ (body-level by doctrine — per-face paint is a render/
 * elevation surface concern, K5's front/back materials, spike §5.2).
 *
 * DISSOCIATION (Q3): a body stores NO reference to whatever plane or element it
 * was drawn on — levelId is view-range/phasing homing only; the geometry is
 * absolute model space and never moves with a level or a host.
 */
import type { CategorySchema } from '../../registry'

export const bodySchema: CategorySchema = {
  id: 'body',
  label: 'Geometry',
  typeParams: {
    groups: [
      {
        label: 'Appearance',
        params: [
          // body-level material: 3D color + cut poché (spike §5.2 — solids fill,
          // open surfaces draw bare cut lines)
          { key: 'material', label: 'Material', kind: 'material', default: '' },
        ],
      },
    ],
  },
  instanceParams: {
    groups: [
      {
        label: 'Geometry',
        params: [
          // the face-edge graph — opaque data, never rendered as a form field
          { key: 'topology', label: 'Topology', kind: 'data', default: null },
        ],
      },
    ],
  },
}
